<script>
import AkSidebar from '@components/v2/general/AkSidebar';

export default {
  components: {AkSidebar},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['hide'],
  methods: {
    hide() {
      this.$emit('hide');
    },
  },
};
</script>

<template>
  <AkSidebar
    :baseZIndex="9998"
    :visible="visible"
    @update:visible="hide"
    block-scroll
    position="right"
    :dismissable="true"
    force-mobile
    style="max-height: 100%; border-radius: 0; padding: 0">
    <template #container>
      <div class="h-screen flex flex-col">
        <div class="px-4 py-4 flex sticky border-grey-100 border-b gap-3 items-center min-h-[64px]">
          <button @click="hide" class="p-2 rounded-md border border-grey-100 text-grey-900">
            <i class="ga-icon ga-chevron_left text-lg" />
          </button>
          <span class="text-[18px] font-semibold text-grey-900">Détail de l'avis</span>
        </div>
        <div class="flex-1 overflow-y-auto overscroll-contain">
          <slot />
        </div>
      </div>
    </template>
  </AkSidebar>
</template>
